// assets/cart-bundle.js
(() => {
  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function updateCart(updates) {
    if (!updates || !Object.keys(updates).length) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates }),
      credentials: 'same-origin'
    });
  }

  async function removeBundle(bundleId, exceptKey = null) {
    if (!bundleId) return;
    const cart = await getCart();
    const updates = {};
    for (const it of cart.items) {
      const b = it.properties && it.properties._bundle;
      if (b && b === bundleId && it.key !== exceptKey) {
        updates[it.key] = 0;
      }
    }
    await updateCart(updates);
  }

  async function syncBundleQty(bundleId, newQty) {
    if (!bundleId) return;
    const cart = await getCart();
    const updates = {};
    for (const it of cart.items) {
      if (it.properties && it.properties._bundle === bundleId) {
        updates[it.key] = newQty;
      }
    }
    await updateCart(updates);
  }

  /** Helpers **/
  function getComposedPathTarget(e, selectorList) {
    const path = (typeof e.composedPath === 'function') ? e.composedPath() : [];
    // 1) czy któryś element ze ścieżki pasuje do któregoś selektora?
    for (const el of path) {
      if (el && el.nodeType === 1) {
        for (const sel of selectorList) {
          try { if (el.matches(sel)) return el; } catch {}
        }
      }
    }
    // 2) fallback: klasyczne closest od oryginalnego targetu
    for (const sel of selectorList) {
      const c = e.target.closest?.(sel);
      if (c) return c;
    }
    return null;
  }

  function getHostOrSelf(el, hostTagNames = []) {
    if (!el) return el;
    // jeśli kliknęliśmy wewnątrz shadowRoot, path znajdzie hosta (np. <cart-remove-button>)
    // ale gdyby nie, spróbujmy podnieść się po rodzicach
    const tag = (el.tagName || '').toLowerCase();
    if (hostTagNames.includes(tag)) return el;
    // jeśli to element wewnątrz shadowRoot, ma .getRootNode().host
    const root = el.getRootNode && el.getRootNode();
    if (root && root.host && hostTagNames.includes((root.host.tagName || '').toLowerCase())) {
      return root.host;
    }
    // klasyczny parentElement chain
    let p = el;
    while (p && p.parentElement) {
      const t = (p.tagName || '').toLowerCase();
      if (hostTagNames.includes(t)) return p;
      p = p.parentElement;
    }
    return el;
  }

  function findLineRow(fromEl) {
    // wyjdź z Shadow DOM do hosta cart-remove-button / quantity-input jeśli trzeba
    const host = getHostOrSelf(fromEl, ['cart-remove-button', 'quantity-input']);
    return host.closest?.('[data-line-key]') || host.closest?.('tr[data-line-key]') || null;
  }

  /** CLICK: usuwanie (obsłuż Shadow DOM) **/
  document.addEventListener('click', async (e) => {
    // różne warianty selektorów z Dawn
    const removeBtn = getComposedPathTarget(e, [
      '[data-cart-remove]',
      'cart-remove-button',
      '[aria-label="Remove"]',
      '[aria-label="Usuń"]'
    ]);
    if (!removeBtn) return;

    const line = findLineRow(removeBtn);
    if (!line) return;

    e.preventDefault();

    const key = line.getAttribute('data-line-key');
    const bundle = line.getAttribute('data-bundle') || null;

    // Usuń klikniętą linię
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
      credentials: 'same-origin'
    });

    // Jeśli to część pakietu – usuń resztę
    if (bundle) {
      await removeBundle(bundle, key);
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
  });

  /** CHANGE/INPUT: synchronizacja ilości w pakiecie (obsłuż Shadow DOM) **/
  function handleQtyEvent(e) {
    const qtyInput = getComposedPathTarget(e, [
      'input[name="updates[]"]',
      'input[data-cart-quantity]',
      'quantity-input input'
    ]);
    if (!qtyInput) return;

    const line = findLineRow(qtyInput);
    if (!line) return;

    const bundle = line.getAttribute('data-bundle') || null;
    if (!bundle) return; // zwykła pozycja — nie ruszamy

    const newQty = parseInt(qtyInput.value || '1', 10);
    if (Number.isNaN(newQty) || newQty < 0) return;

    // debounce krótki, bo Dawn też odświeża AJAX-em
    clearTimeout(handleQtyEvent._t);
    handleQtyEvent._t = setTimeout(async () => {
      await syncBundleQty(bundle, newQty);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }, 120);
  }

  document.addEventListener('change', handleQtyEvent, true);
  document.addEventListener('input', handleQtyEvent, true);
})();
